import * as yup from 'yup';

const PERCENTS_MAX_VALUE = 100;

export const percentsValidationSchema = yup
  .number()
  .positive()
  .typeError('This field is required')
  .max(PERCENTS_MAX_VALUE, `Must be less than or equal to ${PERCENTS_MAX_VALUE}`);
